<template>
  <div>
    <div id="recaptcha"></div>
    <TheHeader/>
      <div class="c-app flex-row align-items-center bg-overlay">    
         <CContainer>
            <CRow class="justify-content-center">
              <CCol md="5">
                <CCardGroup >
                  <CCard class="pl-4 pr-4" style="background-color:rgba(0,0,0,.85); border-radius: 20px;">
                    <CCardBody >
                      <CForm v-if="loginType=='email'">
                        <h1 style="text-align:center; color:white; font-size:28px; padding-bottom:20px;">Sign up</h1>
                        <div class="form-group">
                          <input
                          placeholder="Name"
                          v-model="name"
                          class="form-control material-input "
                          />
                           <small v-if="errors.name" class="form-text text-muted" style="color:red">
                            <p class="text-danger p-0 m-0">{{errors.name}}</p>
                          </small>
                        </div>
                        <div class="form-group">
                          <input
                          placeholder="Email"
                          v-model="email"
                          class="form-control material-input "
                          />
                          <small v-if="errors.email" class="form-text text-muted" style="color:red">
                            <p class="text-danger p-0 m-0">{{errors.email}}</p>
                          </small>
                        </div>
                        <div class="form-group">
                          <input
                            placeholder="Password"
                            type="password"
                            v-model="password"
                            class="form-control material-input "
                          />
                          <small v-if="errors.password" class="form-text text-muted" style="color:red">
                            <p class="text-danger p-0 m-0">{{errors.password}}</p>
                          </small>
                        </div>
                        <div class="form-group">
                          <input
                            placeholder="Confirm Password"
                            type="password"
                            autocomplete="curent-password"
                            v-model="confirmPassword"
                            class="form-control material-input "
                          />
                          <small v-if="errors.confirmPassword" class="form-text text-muted" style="color:red">
                            <p class="text-danger p-0 m-0">{{errors.confirmPassword}}</p>
                          </small>
                        </div>
                        <CRow>
                          <CCol col="12" class="text-left">
                            <button type="button" style="width:100%;border-radius:30px" class="btn btn-lg btn-outline-aumhum" @click="onSignUp">Sign up</button>
                          </CCol>
                          <!-- <CCol col="6" class="text-right">
                            <b-button variant="link" style=";color:#ee8174;" to="/register" >Register Now</b-button>
                          </CCol> -->
                        </CRow>
                      </CForm>
                      <CForm v-if="loginType=='mobile'">
                          <h1 style="text-align:center; color:white; font-size:28px; padding-bottom:20px;">Sign up</h1>
                          <div class="form-group">
                            <input
                            placeholder="Name"
                            v-model="name"
                            class="form-control material-input "
                            />
                            <small v-if="errors.name" class="form-text text-muted" style="color:red">
                              <p class="text-danger p-0 m-0">{{errors.name}}</p>
                            </small>
                          </div>
                          <div class="form-group" v-if="!otpSent">
                            <input
                            placeholder="Mobile"
                            v-model="mobile"
                            class="form-control material-input "
                            />
                            <small v-if="errors.mobile" class="form-text text-muted" style="color:red">
                              <p class="text-danger p-0 m-0">{{errors.mobile}}</p>
                            </small>
                            <small v-else class="form-text text-muted" >
                              <p class=" p-0 m-0">entry mobile number with country code e.g +91 for india</p>
                            </small>
                          </div>
                          <div class="form-group" v-else>
                            <input
                            placeholder="Verification Code"
                            v-model="verificationCode"
                            class="form-control material-input"
                            />
                            <small v-if="errors.password" class="form-text text-muted" style="color:red">
                              <p class="text-danger p-0 m-0">{{errors.verificationCode}}</p>
                            </small>
                          </div>
                          <CRow>
                          <CCol col="12" class="text-left">
                            <button v-if="!otpSent" type="button" style="width:100%;border-radius:30px" class="btn btn-lg btn-outline-aumhum" @click="sendOtpToMobileNumber">Tap to proceed</button>
                            <button v-else type="button" style="width:100%;border-radius:30px" class="btn btn-lg btn-outline-aumhum" @click="onMobileSignUp">Verify</button>
                            <!-- <CButton style="background-color:#ee8174;color:white;"  @click="onSignIn">Login
                              <b-icon v-show="loading" icon="arrow-clockwise" animation="spin" font-scale="1"></b-icon>
                            </CButton> -->
                          </CCol>
                          <!-- <CCol col="6" class="text-right">
                            <b-button variant="link" style=";color:#ee8174;" to="/register" >Register Now</b-button>
                          </CCol> -->
                        </CRow>
                      </CForm>
                    </CCardBody>
                      <CCardFooter >
                          <!-- <CRow >
                              <div style="width:100%; text-align:center;">
                                  <span style="color:#C1C1C1;  border-bottom: solid; border-bottom-color: #C1C1C1">Forgot Password?</span>
                              </div>
                          </CRow> -->
                          <CRow >
                              <p style="width:100%; color:#C1C1C1; text-align:center">OR CONTINUE WITH</p>
                          </CRow>
                          <CRow >
                            <CCol col="12" class="text-center">
                              <img src="/img/Facebook-white-icon@2x.png" style="border: 1px solid #c1c1c1; border-radius:23px;
                                padding: 10px; width: 45px; margin:10px; cursor:pointer;" @click="onFacebookSignUp" />
                              <!-- <b-button   variant="primary" @click="onFacebookSignIn" >Facebook</b-button> -->
                              <img src="/img/Google-white-icon@2x.png" style="border: 1px solid #c1c1c1; border-radius:23px;
                                padding: 10px; width: 45px; margin:10px; cursor:pointer;" @click="onGoogleSignUp" />
                                <img src="/img/Apple-white-icon@2x.png" style="border: 1px solid #c1c1c1; border-radius:23px;
                                padding: 10px; width: 45px; margin:10px; cursor:pointer;" @click="onAppleSignUp" />
                               <span v-if="isMobileLoginEnabled">
                                <img v-if="loginType=='email'" src="/img/mobile-alt-solid.png" style="border: 1px solid #c1c1c1; border-radius:23px;
                                padding: 10px; width: 45px; margin:10px; cursor:pointer;" @click="loginType='mobile'" />
                                <img v-if="loginType=='mobile'" src="/img/envelope-solid.png" style="border: 1px solid #c1c1c1; border-radius:23px;
                                padding: 10px; width: 45px; margin:10px; cursor:pointer;" @click="loginType='email'" />
                              </span> 
                            </CCol>
                            
                          </CRow>
                          <CRow class="pt-4">
                                  <p style="width:100%; color:#C1C1C1; text-align:center">Have an account already? <b-button variant="link" style=" color: #F3756B; padding:0" to="/login" >Login here</b-button></p>
                          </CRow>
                          <CRow v-show="error" class="pt-3">
                            <CCol col="12" class="text-center">
                              <b-alert show variant="danger" dismissible @dismissed="error=''"><strong>Error!</strong> {{error}}</b-alert>
                            </CCol>
                          </CRow>
                      </CCardFooter>

                  </CCard>
                  
                </CCardGroup>
              </CCol>
            </CRow>
          </CContainer>
      </div>
    <TheFooter/>
 <Loading :active.sync="isLoading" 
        color="#F3756B"
        background-color="#000"
        :opacity="0.9"
        loader="spinner"
        :is-full-page="true">
    </Loading>
 </div>
</template>

<script>
import firebase from 'firebase'
import axios from 'axios';
import * as location from '@/utils/location.js'
import '@/assets/app.css'
import TheHeader from '@/components/layout/TheDarkHeader'
import TheFooter from '@/components/layout/TheDarkFooter'
import Loading from 'vue-loading-overlay';

 export default {
  name: 'Registration',
  components: {
   // TheSidebar,
    TheHeader,
    TheFooter,
    Loading,
  },
  data () {
    return {
        email: '',
        password: '',
        confirmPassword:'',
        error:'',
        isLoading:false,
        location:null,
        name:'',
        errors:{},

        loginType:'email',
        otpSent:false,
        mobile:'',
        countryCode:'+91',
        verificationCode:null,
        recaptchaVerifier :null,
        confirmationResult:null,

        isMobileLoginEnabled:false,

    }
  },
  created() {
    this.getCurrentLocation();    
  },
  mounted(){
    
     
  },
  computed : {
    setup(){
      return this.$store.state.user.setup ;
    },

  },
  watch :{

    setup(val){
      console.log(val)
      this.checkMobileLoginEnabled();
    },
    location(val){
       console.log(val)
       this.checkMobileLoginEnabled();
    }

  },
  methods: {
      checkMobileLoginEnabled(){
        if(this.setup!=null&&this.location!=null&&this.setup.metaDefaults.mobile_login&&this.setup.metaDefaults.mobile_login.countries.length){
          // var countryCode = this.location.countryCode.toLowerCase();
          // if(this.setup.metaDefaults.mobile_login.countries.includes(countryCode)){
          //   this.isMobileLoginEnabled = true;
          // }else{
          //   this.isMobileLoginEnabled = false;
          // }
        }
      },
      sendOtpToMobileNumber(){
        var self = this;
        self.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('recaptcha', {
          'size': 'invisible',
          'callback': () => {
          },
          'expired-callback': () => {
          }
        })
        self.recaptchaVerifier.render()
        firebase.auth().signInWithPhoneNumber(self.mobile, self.recaptchaVerifier)
            .then(function (confirmationResult) {
              console.log(confirmationResult)
              self.confirmationResult = confirmationResult;
            }).catch(function (error) {
              console.log(error)
            });
      },
      onMobileSignUp(){
          var self = this;
            self.confirmationResult.confirm(self.verificationCode).then(function(response){
                console.log(response);
                 var body = {};
                 body.location = self.location;
                 body.firstName = self.name;
                 body.userName = response.phoneNumber;
                 body.mobile = response.phoneNumber;
                 body.accessToken = response.ya;

                 var urlTemp = process.env.VUE_APP_API_BASE_URL + '/api/user/firebase/mobile/login';
                 axios.post(urlTemp,body)
                      .then(()=>{
                        self.$store.dispatch('auth/refreshLoginData')
                        .then(()=>{
                              self.$router.replace('/web/profile');
                         });
                      });

            })
            .catch(function(error){
                console.log(error);
            })
          
      },
      onSignUp() {
        var self = this;
        self.errors={};
         if(self.email==''){
           self.errors.email='Incorrect email address'
         }
         if(self.name==''){
           self.errors.name='Mandatory';
         }
         if(self.password==''){
           self.errors.password='Mandatory';
         }
         if(self.confirmPassword==''){
           self.errors.confirmPassword='Mandatory';
         }else if(self.confirmPassword!=self.password){
           self.errors.confirmPassword="Doesn't match";
         }
         if(Object.keys(self.errors).length>0){
           return ;
         }
        var user = {};
        user.location = self.location;
        user.firstName = self.name;
        user.password = self.password;
        user.userName = self.email;
        user.email = self.email;

         //login server to check user does not exist 
         this.isLoading = true;
         var url = process.env.VUE_APP_API_BASE_URL + '/api/secure/user/firebase/login';
         const options = {
            auth: {
              username: this.email,
              password: this.password
            }
         };
         axios.get(url,options)
        .then(() => {
             this.isLoading = false;
             this.error = 'User already exist, please login';
        })
        .catch(() => {
              // validate password 
              //!this.password.match("^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{6,}$")
              if(this.password==''||this.password.length<6){
                this.error = 'Invalid Password';
                this.isLoading = false;
                return;
              }
              if(this.password!=this.confirmPassword){
                this.error = 'Confirm password does not match';
                this.isLoading = false;
                return;
              }
             //create a firebase ac then update 
             firebase.auth()
              .createUserWithEmailAndPassword(this.email,this.password)
              .then(()=>{
                 var urlTemp = process.env.VUE_APP_API_BASE_URL + '/api/user/registration';
                 // add user details to local server 
                 axios.post(urlTemp,user)
                      .then(()=>{
                        firebase.auth()
                          .signInWithEmailAndPassword(this.email, this.password)
                          .then(()=>{
                            this.$store.dispatch('auth/refreshLoginData')
                                .then(()=>{
                                    this.$router.replace('/web/profile');
                                });
                          })
                      });
                 
              })
              .catch(err => {
                this.isLoading = false;
                console.log(err);
                this.error = err.message;
              });
        })

      },
      onFacebookSignUp() {
        const provider = new firebase.auth.FacebookAuthProvider();
        firebase
          .auth()
          .signInWithPopup(provider)
          .then(() => {
              this.$store.dispatch('auth/refreshLoginData')
                  .then(()=>{
                      this.updateUserInfo();
                      this.$router.replace('/web/profile');
                  });
          })
          .catch(err => {
            console.log(err);
            this.error = err.message;
          });

      },
      onGoogleSignUp(){
        const provider = new firebase.auth.GoogleAuthProvider();
        firebase
          .auth()
          .signInWithPopup(provider)
          .then(() => {
              this.$store.dispatch('auth/refreshLoginData')
                  .then(()=>{
                      this.updateUserInfo();
                      this.$router.replace('/web/profile');
                  });
          })
          .catch(err => {
             console.log(err);
             this.error = err.message;
          });

      },
      onAppleSignUp(){
        const provider = new firebase.auth.OAuthProvider('apple.com');
        firebase
          .auth()
          .signInWithPopup(provider)
          .then(() => {
            this.$store.dispatch('auth/refreshLoginData')
                .then(()=>{
                    this.updateUserInfo();
                    this.$router.replace('/web/profile');
                });
          })
          .catch(err => {
             console.log(err);
             this.error = err.message;
          });
      },
      
      updateUserInfo(){
        // update user location and device info 
        var self = this;
        var url = process.env.VUE_APP_API_BASE_URL + '/api/secure/user/location';
        const options = {
          headers: {'Authorization': 'Bearer '+this.$store.getters.accessToken}
        };
        console.log('update location');
        axios.post(url,self.location,options)
        .then(() => {
            this.$store.dispatch('auth/refreshLoginData');
        })
        .catch(e => {
          console.log(e);
        })

      },
      getCurrentLocation(){
        location.getCurrentLocation()
            .then((data) => {
                this.location = data;
                console.log('Location: ', data);
            })
      }


      
       
    }

}
</script>
 
